export default "__VITE_ASSET__CMUzSPt6__"